import "./PublisherLogo.scss";

export type PublisherKey =
  | "google"
  | "facebook"
  | "bing"
  | "yelp"
  | "mapquest"
  | "superpages"
  | "citysearch";

interface Props {
  publisher: PublisherKey;
}

export function PublisherLogo({ publisher }: Props) {
  return (
    <span className={`publisher-logo publisher-logo-${publisher}`}>
      {renderInner(publisher)}
    </span>
  );
}

function renderInner(publisher: PublisherKey) {
  switch (publisher) {
    case "google":
      return <span className="pl-mono">G</span>;
    case "facebook":
      return <span className="pl-mono">f</span>;
    case "bing":
      return <span className="pl-mono">b</span>;
    case "yelp":
      return <span className="pl-mono pl-mono-script">yelp</span>;
    case "mapquest":
      return <span className="pl-mono pl-mono-small">map</span>;
    case "superpages":
      return <span className="pl-mono pl-mono-tiny">superpages.com</span>;
    case "citysearch":
      return (
        <span className="pl-citysearch-mark" aria-hidden>
          <span className="pl-citysearch-ring" />
          <span className="pl-citysearch-dot" />
        </span>
      );
    default:
      return null;
  }
}
